import { render, staticRenderFns } from "./CommitmentModal.vue?vue&type=template&id=154d1b7d"
import script from "./CommitmentModal.vue?vue&type=script&lang=js"
export * from "./CommitmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports